export default [
  {
    path: '/action-log',
    name: 'action-log',
    component: () =>
      import('@/views/modules/action-log/ActionLog.vue'),
    meta: {
      requiresAuth: true,
    },
  },
];
